module.exports = {
  schemas: {
    '2.0.0': require('./schemas/2.0.0.json'),
    '2.1.0': require('./schemas/2.1.0.json'),
    '2.2.0': require('./schemas/2.2.0.json'),
    '2.3.0': require('./schemas/2.3.0.json'),
    '2.4.0': require('./schemas/2.4.0.json'),
    '2.5.0': require('./schemas/2.5.0.json'),
    '2.6.0': require('./schemas/2.6.0.json'),
    '3.0.0': require('./schemas/3.0.0.json'),
    '3.1.0': require('./schemas/3.1.0.json'),
  },
  schemasWithoutId: {
    '2.0.0': require('./schemas/2.0.0-without-$id.json'),
    '2.1.0': require('./schemas/2.1.0-without-$id.json'),
    '2.2.0': require('./schemas/2.2.0-without-$id.json'),
    '2.3.0': require('./schemas/2.3.0-without-$id.json'),
    '2.4.0': require('./schemas/2.4.0-without-$id.json'),
    '2.5.0': require('./schemas/2.5.0-without-$id.json'),
    '2.6.0': require('./schemas/2.6.0-without-$id.json'),
    '3.0.0': require('./schemas/3.0.0-without-$id.json'),
    '3.1.0': require('./schemas/3.1.0-without-$id.json'),
  }
};
